var OKMCart = {
  elements: {
    input_quantity: null,
    btn_plus: null,
    btn_minus: null,
    swiper_thumbs: null,
    swiper_large: null,
    form_fields_container: null
  },
  variants: [],
  selected_variant: 0,
  selected_quantity: 1,
  price_tag: null,
  compare_price_tag: null,
  select_options: null,
  select_option1: null,
  select_option2: null,
  select_option3: null,
  hostname: 'https://www.okmdetectors.com',
  template_view: '',

  addToCart: function(){
    let props = '';
    let submit = false;
    const form = document.querySelector('#form_add_to_cart');

    if (form)
    {
      if (!form.checkValidity())
      {
        form.reportValidity(); 
      }
      else
      {
        submit = true;
        const fields = form.querySelectorAll('[name^="properties["]');
        fields.forEach(field => {
          props += '&' + field.name + '=' + field.value;        
        });
      }
    }

    if (submit)
    {
      var url = this.hostname + '/cart/add?view=' + this.template_view + '&id=' + this.variants[this.selected_variant].shop_variant_id + '&quantity=' + this.selected_quantity + props;
      //console.log( url );
      window.location = url;
    }
  },

  changeQuantity: function(){
    var b = document.getElementById( 'okm-quantity-selector' );
    if ( b ) {
      this.selected_quantity = b.value;
    }
  },

  updateOption1: function(s){
    if (s) {
      var o1 = this.select_option1;
      if ( o1 != null ) { o1.value = this.variants[s].option1; o1.blur(); }
    }
  },
    
  updateOption2: function(s){
    if ( this.select_option1 && this.select_option2 )
    {
      var value = this.select_option1.value;

      while ( this.select_option2.length > 0 ){
        this.select_option2.remove( 0 );
      }
      
      var sel = false;
      for ( i = 0; i < this.variants.length; i++ )
      {
        var variant = this.variants[i];
        
        if ( variant.option1 == value )
        {
          const opt = document.createElement("option");
          opt.value = variant.option2;
          opt.text = variant.option2;
          
          this.select_option2.add( opt );
          if ( sel == false ) { this.select_option2.value = variant.option2; sel = true; }
        }
      }

      if (s) {
        var o2 = this.select_option2;
        if ( o2 != null ) { o2.value = this.variants[s].option2; o2.blur(); }
      }
    }
  },

  updateOption3: function(s){
    if (s) {
      var o3 = this.select_option3;
      if ( o3 != null ) { o3.value = this.variants[s].option3; o3.blur(); }
    }
  },

  changeOptions: function(){
    if ( this.select_options ) {
      var sv = this.variants[ this.select_options.value ];
      if ( sv ) {

        if ( this.select_option1 ) {
          this.select_option1.value = sv.option1;
          this.updateOption2();

          if ( this.select_option2 ) {
            this.select_option2.value = sv.option2;
            this.updateOption3();

            if ( this.select_option3 ) {
              this.select_option3.value = sv.option3;
            }
            
          }

        }

      }

      this.updatePrice();
      this.updateImage();
      this.renderFormFields();
    }
  },
  
  changeOption1: function(s){
    this.updateOption1(s);
    this.updateOption2(s);
    this.updateOption3(s);
    this.changeVariant();
  },

  changeOption2: function(){
    this.updateOption3();
    this.changeVariant();
  },

  changeOption3: function(){
    this.changeVariant();
  },
  
  changeVariant: function(){
    var b = document.getElementById( 'okm-variant-selector' );
    if ( b ) {
      
      var value1 = value2 = value3 = "";
      o1 = this.select_option1;
      if ( o1 != null ) { value1 = o1.value; o1.blur(); }
      
      o2 = this.select_option2;
      if ( o2 != null ) { value2 = o2.value; o2.blur(); }
      
      o3 = this.select_option3;
      if ( o3 != null ) { value3 = o3.value; o3.blur(); }

      var exists = false;
      for ( i = 0; i < this.variants.length; i++ )
      {
        var variant = this.variants[i];
        if ( ( value1 == variant.option1 ) && ( value2 == variant.option2 ) && ( value3 == variant.option3 ) )
        {
          this.selected_variant = i;
          let paramStr = '';
          const searchParams = new URLSearchParams( window.location.search );
          searchParams.forEach( (value, key) => {
            if ( key != 'variant' ) paramStr += '&' + key + '=' + value;
          });          
          window.history.replaceState( null, null, location.pathname + '?variant=' + variant.id + paramStr );
          exists = true;
          break;
        }
      }

      //if ( exists )
      {
        
        this.updatePrice();
        this.updateImage();
        this.renderFormFields();
        this.updateFixedCart();        
      }
      
    }
  },

  clickInc: function(){
    if ( this.elements.input_quantity && this.elements.btn_plus ) {
      this.selected_quantity++;
      this.elements.input_quantity.value = this.selected_quantity;
    }
  },

  clickDec: function(){
    if ( this.elements.input_quantity && this.elements.btn_minus ) {
      if ( this.selected_quantity > 1 ) { this.selected_quantity--; }
      this.elements.input_quantity.value = this.selected_quantity;
    }
  },

  updateFixedCart: function (){
    if ( this.select_options ) {
      this.select_options.value = this.selected_variant;
    }
  },

  updatePrice: function(){
    const prices = this.variants[this.selected_variant].prices;
    for ( i = 0; i < prices.length; i++ ) {
      const e = document.querySelector('#js-price-'+i);
      if (e) e.innerHTML = prices[i][0];
      if (i == 0) {
        const e = document.querySelector('#js-price-compare-'+i);
        if (e) e.innerHTML = prices[i][1];
      }
    }
  },

  updateImage: function(){

    let e = document.querySelectorAll(".swiper-slide,.non-swiper-slide");
    if (e)
    {
      let d = null;
      for ( i = 0; i < e.length; i++ )
      {
        e[i].removeAttribute("class");
        e[i].removeAttribute("style");
        e[i].removeAttribute("data-swiper-slide-index");
        e[i].removeAttribute("aria-label");
        
        d = e[i].getAttribute('data-filter');
        if ( ( d ) && ( d.length > 1 ) )
        {
          if ( d.includes( this.variants[this.selected_variant].sku ) )
          { // enable / show
            e[i].classList.add('swiper-slide');
          }
          else
          { // disable / hide
            e[i].classList.add('non-swiper-slide');
          }
        }
        else e[i].classList.add('swiper-slide');
      }
    }
     
    if (this.elements.swiper_large)
    {
        //this.elements.swiper_large.init(".swiper_large_preview");
        this.elements.swiper_large.update();
        this.elements.swiper_large.slideTo(0,0,false);
        //console.log('Update( swiper_large )');

        if (this.elements.swiper_thumbs)
        {
          //this.elements.swiper_thumbs.init(".swiper_thumb");
          this.elements.swiper_thumbs.update();
          this.elements.swiper_thumbs.slideTo(0,0,false);
          //console.log('Update( swiper_thumbs )');
        }
    }
      
  },

  renderFormFields: function(){
    const container = this.elements.form_fields_container;
    if (!container) return;

    const variant = this.variants[this.selected_variant];
    container.innerHTML = '';

    if (!variant || !variant.form_fields || variant.form_fields.length === 0) return;

    variant.form_fields.forEach(function (field) {
      const wrapper = document.createElement('div');
      wrapper.className = 'mb-3';

      const label = document.createElement('label');
      label.setAttribute('for', field.name);
      label.className = 'form-label';
      label.innerHTML = field.label + (field.required ? ' <span class="okm-form-required">*</span>' : '');
      wrapper.appendChild(label);

      const input = document.createElement('input');
      input.type = 'text';
      input.className = 'form-control';
      input.id = field.name;
      input.name = 'properties[' + field.name + ']';
      input.placeholder = field.placeholder || '';
      if (field.required) input.required = true;

      if (field.type === 'Software Key') {
        input.maxLength = 29;
        input.autocomplete = 'off';
        input.pattern = '^[A-Za-z0-9]{5}-[A-Za-z0-9]{5}-[A-Za-z0-9]{5}-[A-Za-z0-9]{5}-[A-Za-z0-9]{5}$';
        input.addEventListener('input', function () {
          let value = this.value.toUpperCase().replace(/[^A-Za-z0-9-]/g, '').replace(/-/g, '').substring(0, 25);
          const groups = value.match(/.{1,5}/g);
          this.value = groups ? groups.join('-') : '';
        });

        const urlParams = new URLSearchParams(window.location.search);
        const swk = urlParams.get('swk');
        if (swk !== null) {
          input.value = swk;
        }        
      }

      wrapper.appendChild(input);
      container.appendChild(wrapper);
    });
  },
}